<template>
  <div class="mt-6 md:mt-0">
    <div class="px-0 pb-1 sm:px-4">
      <div class="flex rounded-md shadow-sm">
        <div class="relative flex-grow focus-within:z-10">
          <div
            class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
          >
            <svg
              class="w-5 h-5 text-gray-400"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z"
              />
            </svg>
          </div>
          <input
            v-model="query"
            class="block w-full pl-10 transition duration-150 ease-in-out rounded-none form-input rounded-l-md md:rounded-md sm:text-sm sm:leading-5"
          />
        </div>
        <router-link
          tag="button"
          :to="`/patients/${patient.id}/examination/new`"
          class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium leading-5 text-white transition duration-150 ease-in-out bg-indigo-600 border border-transparent md:hidden rounded-r-md hover:bg-indigo-500 focus:outline-none"
        >
          <svg fill="currentColor" viewBox="0 0 20 20" class="w-5 h-5">
            <path
              fill-rule="evenodd"
              d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <span class="ml-2">Visita</span>
        </router-link>
      </div>
    </div>
    <div class="list">
      <ul v-if="filtered.length" class="scrollable">
        <li
          v-for="examination in filtered"
          :key="examination.id"
          class="border-t border-gray-200"
        >
          <router-link
            :to="`/patients/${patient.id}/examination/${examination.id}`"
            class="block transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus:bg-gray-50"
          >
            <div class="flex items-center px-4 py-4 sm:px-6">
              <div class="flex items-center w-full">
                <div class="w-full md:w-1/4">
                  <div
                    class="text-sm font-medium leading-5 text-indigo-600 truncate"
                  >
                    {{ examination.date | prettydate }}
                  </div>
                  <div
                    v-if="examination.photos_count || examination.files_count"
                    class="flex items-center mt-1 text-sm leading-5 text-gray-500"
                  >
                    <span>
                      <div class="flex text-sm leading-5 text-gray-900">
                        <svg
                          v-if="examination.photos_count"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          class="w-5 h-5 text-gray-400"
                        >
                          <path
                            d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z"
                          ></path>
                        </svg>
                        <svg
                          v-if="examination.files_count"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          class="w-5 h-5 text-gray-400"
                        >
                          <path
                            d="M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"
                          ></path>
                          <path
                            d="M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z"
                          ></path>
                        </svg>
                      </div>
                    </span>
                  </div>
                  <div
                    class="flex items-center mt-1 text-sm leading-5 text-gray-500"
                  >
                    <span>
                      <div class="text-sm leading-5 text-gray-900">
                        {{ examination.price }}
                      </div>
                    </span>
                  </div>
                </div>
                <div class="flex-1 hidden min-w-0 px-4 md:block">
                  <div>
                    <div
                      class="text-sm leading-5 text-gray-900"
                      v-html="examination.preview"
                    ></div>
                  </div>
                </div>
              </div>
              <div>
                <svg
                  class="w-5 h-5 text-gray-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.list {
  height: calc(100% - 36px);
}
</style>

<script>
import { mapState } from "vuex";

export default {
  data: () => {
    return {
      query: "",
    };
  },
  computed: {
    ...mapState("patient", ["patient"]),
    filtered() {
      return _.filter(this.patient.examinations, (element) => {
        return this.query
          ? element.diagnosis &&
              element.diagnosis.toUpperCase().search(this.query.toUpperCase()) >
                -1
          : element;
      });
    },
  },

  methods: {
    save() {
      this.$store.dispatch("patient/SAVE", this.patient);
    },
    destroy() {
      if (confirm("Sicuro di voler cancellare il paziente?")) {
        this.$store.dispatch("patient/DELETE");
        this.$router.go(-1);
      }
    },
  },
};
</script>
